module.exports = __webpack_public_path__ + "img/Frente-36-00 off.2b40e66f.png";